
import { useState, useEffect } from "react";

/**
 * Hook for managing initial reagent load retry logic
 */
export const useReagentRetry = (
  loadingReagents: boolean, 
  isFetching: boolean, 
  authLoading: boolean, 
  user: any, 
  reagents: any[], 
  isError: boolean,
  refetchReagents: () => Promise<any>,
  setIsRetrying: (value: boolean) => void
) => {
  const [hasAttemptedLoad, setHasAttemptedLoad] = useState(false);

  // Initial load retry logic
  useEffect(() => {
    if (!hasAttemptedLoad && !loadingReagents && !isFetching && !authLoading && user) {
      console.log("Initial reagent load check - setting hasAttemptedLoad");
      setHasAttemptedLoad(true);
      
      if (reagents.length === 0 || isError) {
        console.log("No reagents found or error occurred, forcing refetch after delay");
        const timer = setTimeout(() => {
          console.log("Executing delayed refetch");
          setIsRetrying(true);
          refetchReagents().finally(() => setIsRetrying(false));
        }, 1500);
        
        return () => clearTimeout(timer);
      }
    }
  }, [loadingReagents, reagents.length, refetchReagents, isError, hasAttemptedLoad, isFetching, authLoading, user, setIsRetrying]);
};
